export const ENTER = 13;
export const UP_ARROW = 38;
export const DOWN_ARROW = 40;
export const ESCAPE = 27;
export const TAB = 9;
export const END = 35;
export const HOME = 36;
export const SHIFT = 16;
